<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.913" height="20" viewBox="0 0 20.913 20">
    <path class="star-icon" d="M11.467,1.675l2.359,4.779a1.126,1.126,0,0,0,.848.616l5.275.766a1.126,1.126,0,0,1,.624,1.921l-3.817,3.72a1.126,1.126,0,0,0-.324,1l.9,5.253A1.126,1.126,0,0,1,15.7,20.915l-4.717-2.48a1.127,1.127,0,0,0-1.048,0l-4.717,2.48a1.126,1.126,0,0,1-1.634-1.187l.9-5.253a1.126,1.126,0,0,0-.324-1L.342,9.757A1.126,1.126,0,0,1,.966,7.836L6.241,7.07a1.126,1.126,0,0,0,.848-.616L9.448,1.675A1.126,1.126,0,0,1,11.467,1.675Z" transform="translate(0 -1.047)" fill="#bce0fd"/>
  </svg>
</template>

<script>
  export default {
    name: 'StarIcon'
  }
</script>

<style>
</style>